export const getFeatureFlag = (flag) => () => {
  return (Skubacz.configuration.feature_flags || {})[flag] ?? false;
};
